import React, { useState } from 'react';
import * as dateFns from 'date-fns';
import { Link } from 'react-router-dom';

import { modalRoute, msToTime, text_truncate } from '../../../../../helpers';
import { useInterval, useRouter } from '../../../../../helpers/customHooks';
import { FUTURE } from '../../../../../config/constants';
import { PracticePropsType } from '../types';
import { useUserState } from '../../../../../store/hooks';

const Practice = ({ event, disabled }: PracticePropsType) => {
  
  const user = useUserState();
  const { pathname } = useRouter();
  
  const date = new Date();
  const now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
    date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  let elapsed = dateFns.getTime(now_utc) - event.startTime;
  if (event.live && event.currentDrillIndex < event.drills.length) {
    elapsed = dateFns.getTime(now_utc) - event.drills[0].startTs;
  }
  if (event.live && event.startTime > now_utc) {
    elapsed = 0;
  }
  const [elapsedTime, setElapsedTime] = useState(elapsed);
  useInterval(() => {
    if (event.live) {
      const date = new Date();
      const now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
        date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
      if (event.currentDrillIndex < event.drills.length) {
        setElapsedTime(dateFns.getTime(now_utc) - event.drills[0].startTs);
      } else {
        setElapsedTime(dateFns.getTime(now_utc) - event.startTime);
      }
    }
  }, 1000);
  // if (goToLive) {
  //   return <Redirect to={{pathname: `/live-practices/${event.gameId}`, state: {event: event}}}/>
  // }
  const duration = event.status === FUTURE ? 900000 : dateFns.differenceInMilliseconds(event.drills.length ? event.drills[event.drills.length - 1].endTs : 
    90000, event.drills.length ? event.drills[0].startTs : 0);
  const startPosition = dateFns.getMinutes(event.status === 'post' && event.drills.length ? event.drills[0].startTs : event.startTime) * 1.1;
  const practiceDuration = (duration / 1000 / 60) * 1.1;
  let heightCard = practiceDuration > 49.5 ? practiceDuration : practiceDuration < 16.5 ? 16.5 : practiceDuration;
  const topPosition = dateFns.getHours(event.status === 'post' && event.drills && event.drills.length && event.drills[0].startTs ? event.drills[0].startTs : 
    event.startTime) * 60 * 1.1 + startPosition;
  const maxHeight = 24 * 60 * 1.1;
  heightCard = event.live ? 66 : (topPosition + heightCard > maxHeight ? maxHeight - topPosition : heightCard);
  
  return (
    <Link to={{ pathname: modalRoute(pathname, event, disabled, user), state: { toReturn: pathname } }}>
      <div
        className="event-card"
        id={`practice-card-${event.live ? 'live' : dateFns.isFuture(event.startTime) ? 'future' : 'post'}-${event.name}-${dateFns.format(new Date(event.startTime), 'yyyy-MMMM-dd')}`}
        style={{
          marginLeft: `${4 + event.z_index * 6}px`,
          width: `${163}px`,
          marginTop: `${startPosition}px`,
          height: `${event.live ? 73 : !disabled ? (heightCard > 49.5 && heightCard < 73) ? 73 : heightCard : 16.5}px`,
          zIndex: (1 + event.z_index) * 5,
          borderColor: event.live ? '#00658b' : 'black',
          boxShadow: event.live ? '0px 1px 5px rgba(0,0,0,0.4)' : undefined,
          opacity: event.live ? 1 : undefined
        }}
      >
        <div className="card-games">
          <div
            className="practice-title lll-p"
            style={disabled || (heightCard < 49.5 && !event.live) ? { padding: `${heightCard < 22 ? 0 : heightCard / 3.3}px 8px` } : event.live ? { color: '#00658b' } : undefined}
          >
            {heightCard < 49.5 ? text_truncate(event.name, 10) : text_truncate(event.name, 18)}
            {disabled ?
              <div className="future-practice-time">
                {dateFns.format(new Date(event.startTime), 'hh:mm a')}
              </div>
              :
              event.live ?
                <div className="live-indicator">
                  <img src="/assets/images/rec.svg" alt="" width="12px" className="led-img img-live" />
                  LIVE
                </div>
                :
                heightCard < 49.5 ?
                  <div className="g-r"><i className="mdi mdi-timer-outline" style={{ color: 'green' }} /> {msToTime(duration)}
                  </div>
                  :
                  null
            }
          </div>
          {!disabled && heightCard > 49.5 ?
            <div className="time-intensity">
              {
                event.live ?
                  <div className="time-range">
                    <span
                      style={{ fontWeight: 'bold' }}
                    >STARTED:</span> {dateFns.format(new Date(event.drills && event.drills.length && event.drills[0].startTs ? event.drills[0].startTs : event.startTime), 'hh:mm aaaaa\'m\'')}
                  </div>
                  :
                  <div className="time-range">
                    {event.drills && event.drills[0].startTs ?
                      dateFns.format(new Date(event.drills[0].startTs), 'hh:mm aaaaa\'m\'')
                      :
                      dateFns.format(new Date(event.startTime), 'hh:mm aaaaa\'m\'')
                    }-{
                    event.drills && event.drills[event.drills.length - 1].endTs ?
                      dateFns.format(new Date(event.drills[event.drills.length - 1].endTs), 'hh:mm aaaaa\'m\'')
                      :
                      dateFns.format(new Date(event.endTime), 'hh:mm aaaaa\'m\'')
                  }
                  </div>
              }
              {/* {!event.live ?
               <div className="intensity"><span style={{fontWeight: 'bold'}}>INT:</span> {event.intensity}
               </div> : null} */}
            </div>
            : null}
          {disabled ? null :
            <>
              {heightCard > 49.5 && <div className="practice-duration">
                <div
                  className="g-l"
                >{event.live && event.currentDrillIndex < event.drills.length ? text_truncate(event.drills[event.currentDrill].drillType, 14) : 
                  `${event.drills.length} ${event.drills.length === 1 ? 'Period' : 'Periods'}`}</div>
                <div className="g-r" style={event.live ? { color: '#00658b' } : {}}><i
                  className="mdi mdi-timer-outline"
                  style={event.live ? { color: '#00658b' } : { color: 'green' }}
                /> {event.live ? msToTime(elapsedTime) : msToTime(duration)}
                </div>
              </div>}
              {/* <Metric
               label='AVG. TOTAL DIST. (YDS)'
               current={event.dist.current}
               target={event.dist.target} />
               <Metric
               label='AVG. HARD EFFORT DIST. (YDS)'
               current={event.effort.current}
               target={event.effort.target} />
               <SpeedMetric
               label='AVG. MAX SUST. SPEED'
               current={event.speed.current}
               target={event.speed.target}
               max={event.speed.max} /> */}
            </>
          }
        </div>
      </div>
    </Link>
  );
};

export default Practice;
